<template>
    <div class>
        <section class="checkout_wizard pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div
                            class="wizard d-flex justify-content-center align-items-center"
                        >
                            <router-link :to="{ name: 'cartV3' }">
                                <div
                                    class="field d-flex justify-content-center align-items-center"
                                >
                                    <div class="circle done mr_10">
                                        <img
                                            src="/maincss/images/wizard_checked.svg"
                                            alt
                                        />
                                    </div>
                                    <h5 class="mb-0">Shopping Cart</h5>
                                </div>
                            </router-link>

                            <div class="devider"></div>
                            <div
                                v-if="is_reviewpay || is_payment"
                                @click="
                                    manageUpperThreeLinks('shipping_billing')
                                "
                                class="wizard field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>

                                <h5 class="mb-0">Shipping & Billing Address</h5>
                            </div>

                            <div
                                v-else
                                class="wizard field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">2</div>
                                <h5 class="mb-0">Shipping & Billing Address</h5>
                            </div>

                            <div class="devider"></div>
                            <div
                                v-if="is_payment || is_reviewpay"
                                @click="
                                    manageUpperThreeLinks('payment_shipment')
                                "
                                class="wizard field d-flex justify-content-center align-items-center"
                            >
                                <div
                                    class="circle done mr_10"
                                    v-if="is_reviewpay"
                                >
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <div v-else class="circle mr_10">3</div>
                                <h5 class="mb-0">Payment & Shipment</h5>
                            </div>
                            <div
                                v-else
                                class="wizard field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">3</div>
                                <h5 class="mb-0">Payment & Shipment</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                @click="manageUpperThreeLinks('review_pay')"
                                v-if="is_reviewpay"
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">4</div>
                                <h5 class="mb-0">Review & Pay</h5>
                            </div>
                            <div
                                v-else
                                class="field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">4</div>
                                <h5 class="mb-0">Review & Pay</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb" v-if="false">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }"
                                >Home</router-link
                            >
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'cart' }"
                                >Cart</router-link
                            >
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="checkout_error_msg p-0">
            <div class="container">
                <div class="row">
                    <div v-show="email_verified" class="col-md-12">
                        <div
                            class="alert alert-danger d-flex justify-content-between align-items no-cart-message"
                            role="alert"
                        >
                            <div class="alert_message">
                                <span>
                                    Please verify your account to complete
                                    checkout process!</span
                                >
                            </div>
                            <div class="alert_btn">
                                <a
                                    href="#"
                                    class="btn bnt-primary mr_20 refresh"
                                    @click="forceRerender"
                                    >Refresh</a
                                >
                                <a
                                    href="#"
                                    class="btn bnt-primary"
                                    @click="resendLink"
                                    >Resend Link</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="shipping_payment_detail shipping_payment pt-0 pb_150">
            <div class="container">
                <div class="row" v-if="is_reviewpay"></div>
                <div class="row">
                    <ReviewPay
                        ref="reviewPayComp"
                        v-show="is_reviewpay"
                        :order_data="order_data"
                        :termPaymentInfo="term_payment_info"
                    />
                    <ShippingPayment v-show="!is_reviewpay && !is_payment" />
                    <PaymentShipment
                        v-show="!is_reviewpay && is_payment"
                        :order_data="order_data"
                        :netsuite_customer_data="netsuite_customer_data"
                        :termPaymentInfo="term_payment_info"
                        :enableTermPayment="true"
                        ref="PayShipmentRef"
                    />
                    <CartSummary
                        :is_reviewpay="is_reviewpay"
                        :order_data="order_data"
                        ref="cartSummaryRef"
                    />
                    <!-- v-show="cartNotEmpty" -->
                </div>
            </div>
        </section>

        <!-- <div v-if="is_reviewpay" class="container">
            <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <div class="procced_to_pay_btn_rv">
                        <button
                            v-if="isAdminLoggedIn"
                            v-on:click="placeOrder"
                            class="btn btn_orange bg_primary_orange text_white d-block py_22"
                            style="width: 571px; margin: 0 auto"
                        >
                            Proceed To Checkout
                        </button>
                         <button
                            v-else
                            v-on:click="placeOrder"
                            class="btn btn_orange bg_primary_orange text_white d-block py_22"
                            style="width: 571px; margin: 0 auto"
                        >
                            Proceed To Pay 
                        </button>
                    </div>
                    <center class="procced_to_pay_terms by_placing_spaceing">
                        <p class="font_size_16 text_light_grey">
                            By placing your order at
                            <router-link class="opacity_60" :to="{ path: '/' }"
                                >imprintcity.com</router-link
                            >
                            you're agreeing to our
                            <br />
                            <router-link
                                class="opacity_60"
                                :to="{ name: 'PrivacyPolicy' }"
                                >Privacy Policy</router-link
                            >
                            &
                            <router-link
                                class="opacity_60"
                                :to="{ name: 'TermsConditions' }"
                                >Terms & Conditions</router-link
                            >. We may occasionally email you product
                            information.
                        </p>
                    </center>
                </div>
                <div class="col-md-3"></div>
            </div>
        </div> -->
        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon class="rect" points="0 0 0 40 40 40 40 0" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import CartSummary from "@/components/cart/V3/CartSummary";
import ShippingPayment from "@/components/ShippingPayment";
import PaymentShipment from "@/components/PaymentShipmentV2";
import ReviewPay from "@/components/ReviewPay";
import ApiService from "@/common/api.service";

export default {
    /* eslint-disable */
    name: "Checkout",
    /* eslint-enable */
    components: { CartSummary, ShippingPayment, ReviewPay, PaymentShipment },
    data() {
        return {
            email_verified: false,
            getting_email: null,
            total_weight_in_lbs: 0.0,
            cartLoading: false,
            isLoader: false,
            placingOrder: false,
            is_reviewpay: false,
            is_payment: false,
            all_states: [],
            address_data: {
                address1: "",
                address2: "",
                state: "",
                city: "",
                pincode: ""
            },
            all_address: [],
            shippingCarriers: [],
            order_data: {
                fullname: "",
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                billingaddressid: "",
                shippingaddressid: "",
                sameaddress: true,
                billing_first_name: "",
                billing_last_name: "",
                address_label: "",
                addresszip: "",
                addressstate: "",
                billingcountry: "United States Of America",
                shipping_first_name: "",
                shipping_last_name: "",
                shippingaddress_label: "",
                shippingphone: "",
                shippingaddresszip: "",
                shippingaddressstate: "",
                shippingcountry: "United States Of America",
                shippingproviderid: "",
                shipping_provider_name: "",
                shippingmethod: "",
                giftcardnumber: "",
                giftcardpin: "",
                couponcode: "",
                specialcomment: "",
                comment: "",
                is_paypal: "",
                is_cod: 0,
                is_pay_later: 0,
                is_credit_card: "",
                total_price: "",
                grand_total_price: "",
                total_quantity: "",
                items: "",
                shippingproviderimage: "",
                grand_total: "",
                order_price: 0,
                shipping_price: "",
                credit_limit: "",
                sales_tax: 0,
                is_remaining_pay_card: false,
                remaining_pay_card_details: {
                    id: "",
                    cardtype: "",
                    cardimage: "",
                    cardnumber: "",
                    cardholdername: "",
                    cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(
                        -2
                    ),
                    cardexpireyear: new Date()
                        .getFullYear()
                        .toString()
                        .substr(-2),
                    customerPaymentProfileId: "",
                    customerProfileId: "",
                    cardsecuritycode: ""
                },
                total_non_standard_fees: 0,
                total_color_fees: 0,
                total_setup_fees: 0,
                admin_user_id: 0
            },
            selected_shiping_method: null,
            creditLimit: null,
            pay_type: null,
            netsuite_customer_data: null,
            total_orders: 0,
            unsynced_orders_amount: 0,
            term_payment_info: {
                creditlimit: 0,
                overdue_balance: 0,
                unbilled_orders: 0,
                unpaid_invoices: 0,
                avalaible_on_account: 0,
                unapplied_credits: 0
            }
        };
    },
    mounted() {
        /* eslint-disable */
        if (!this.isAuthenticatedClient) {
            $("#login").modal("show");
            this.$router.push({ name: "/home" });
        }
        var _this = this;
        document.body.classList.add("bg_primary_light_white");
        $(document).on("hide.bs.modal", "#address", function () {
            _this.$validator.reset();
            _this.address_data = {
                address1: "",
                address2: "",
                state: "",
                city: "",
                pincode: ""
            };
            //Do stuff here
        });
        /* eslint-enable */
        _this.cartNotEmpty = localStorage.getItem("cartNotEmpty");
        this.getUser();
        this.getOrdersCount();
    },
    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "isAdminLoggedIn"
        ]),
        tag() {
            return this.$route.params.tag;
        }
    },
    methods: {
        resendLink() {
            var _this = this;
            new Promise(() => {
                setTimeout(() => {
                    ApiService.get(
                        "/send-email-verification-link/" + this.getting_email
                    )
                        .then(({ data }) => {
                            _this.$toast.success(data.message, {
                                position: "top-right"
                            });
                        })
                        .catch(({ response }) => {
                            console.log(response.status.errors);
                        });
                }, 500);
            });
        },
        forceRerender() {
            this.$router.go(this.$router.currentRoute);
        },
        manageUpperThreeLinks(type) {
            var _this = this;
            if (type == "shipping_billing") {
                _this.is_reviewpay = false;
                _this.is_payment = false;
            } else if (type == "payment_shipment") {
                _this.is_reviewpay = false;
                _this.is_payment = true;
            } else if (type == "review_pay") {
                _this.is_reviewpay = true;
                _this.is_payment = false;
            }
        },
        getStates() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/states")
                    .then(({ data }) => {
                        _this.all_states = data.states;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        getAddresses() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/addresses")
                    .then(({ data }) => {
                        _this.all_address = data.address;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },

        placeOrder() {
            var _this = this;

            // Prevent duplicate order placement
            if (_this.isLoader || _this.placingOrder) {
                console.log(
                    "Order placement already in progress, ignoring duplicate call"
                );
                return;
            }

            _this.placingOrder = true;
            // Use calculatedGrandTotal instead of grand_total for accurate total_price
            _this.order_data.total_price =
                _this.$refs.cartSummaryRef.calculatedGrandTotal;
            _this.order_data.shipping_price =
                _this.$refs.cartSummaryRef.shippingPrice;
            _this.order_data.total_setup_fees =
                _this.$refs.cartSummaryRef.total_setup_fee;
            _this.order_data.total_color_fees =
                _this.$refs.cartSummaryRef.total_imprint_locations_price;

            // Use calculatedGrandTotal which already includes all fees (base, run charge, color mix, setup, non-standard), shipping, and sales tax
            const calculatedGrandTotal = _this.$refs.cartSummaryRef.calculatedGrandTotal;
            _this.order_data.grand_total_price = calculatedGrandTotal.toFixed(2);
            _this.order_data.order_price = parseFloat(
                calculatedGrandTotal.toFixed(2)
            );
            _this.order_data.total_quantity =
                _this.$refs.cartSummaryRef.total_quantity;

            // Ensure displayData breakdowns are available in cart_items before sending
            let cart_items = _this.$refs.cartSummaryRef.cart_items;
            if (cart_items && cart_items.length > 0) {
                cart_items.forEach((item) => {
                    // Recalculate displayData to ensure breakdowns are fresh
                    const freshDisplayData =
                        _this.$refs.cartSummaryRef.getItemDisplayData(item);
                    if (freshDisplayData) {
                        item.displayData = freshDisplayData;
                        // Ensure runChargeBreakdown is properly set in displayData
                        if (freshDisplayData.runChargeBreakdown) {
                            item.displayData.runChargeBreakdown =
                                freshDisplayData.runChargeBreakdown;
                            // Also add directly to item for easier access
                            item.runChargeBreakdown =
                                freshDisplayData.runChargeBreakdown;
                        }
                        // Ensure baseFeeBreakdown is properly set (always set, even if null)
                        item.displayData.baseFeeBreakdown =
                            freshDisplayData.baseFeeBreakdown || null;
                        item.baseFeeBreakdown =
                            freshDisplayData.baseFeeBreakdown || null;

                        // Ensure customColorBreakdown is properly set (always set, even if null)
                        item.displayData.customColorBreakdown =
                            freshDisplayData.customColorBreakdown || null;
                        item.customColorBreakdown =
                            freshDisplayData.customColorBreakdown || null;
                    }
                    // Also ensure subItems have displayData
                    if (item.subItems && item.subItems.length > 0) {
                        item.subItems.forEach((subItem) => {
                            const freshSubDisplayData =
                                _this.$refs.cartSummaryRef.getItemDisplayData(
                                    subItem
                                );
                            if (freshSubDisplayData) {
                                // Deep copy to avoid Vue reactivity issues
                                subItem.displayData = JSON.parse(
                                    JSON.stringify(freshSubDisplayData)
                                );
                                // Ensure runChargeBreakdown for subItems (location-wise structure)
                                if (freshSubDisplayData.runChargeBreakdown) {
                                    subItem.displayData.runChargeBreakdown =
                                        freshSubDisplayData.runChargeBreakdown;
                                    subItem.runChargeBreakdown =
                                        freshSubDisplayData.runChargeBreakdown;
                                }
                                // Ensure baseFeeBreakdown for subItems (always set, even if null)
                                subItem.displayData.baseFeeBreakdown =
                                    freshSubDisplayData.baseFeeBreakdown ||
                                    null;
                                subItem.baseFeeBreakdown =
                                    freshSubDisplayData.baseFeeBreakdown ||
                                    null;

                                // Custom color breakdown: NULL for sub items if grouped
                                // Check if parent is grouped decoration type 0
                                const isGrouped =
                                    _this.$refs.cartSummaryRef.isGroupedDecorationType0(
                                        item
                                    );
                                if (isGrouped) {
                                    // For grouped items, custom color is shown at parent level, so null for sub items
                                    subItem.displayData.customColorBreakdown =
                                        null;
                                    subItem.customColorBreakdown = null;
                                } else {
                                    // For non-grouped items, include custom color breakdown (always set, even if null)
                                    subItem.displayData.customColorBreakdown =
                                        freshSubDisplayData.customColorBreakdown ||
                                        null;
                                    subItem.customColorBreakdown =
                                        freshSubDisplayData.customColorBreakdown ||
                                        null;
                                }
                            }
                        });
                    }
                });
            }

            _this.order_data.items = cart_items;
            if (localStorage.getItem("billingAddressIdAfterNewAddress")) {
                _this.order_data.billingaddressid = localStorage.getItem(
                    "billingAddressIdAfterNewAddress"
                );
            }
            if (localStorage.getItem("shippingAddressIdAfterNewAddress")) {
                _this.order_data.shippingaddressid = localStorage.getItem(
                    "shippingAddressIdAfterNewAddress"
                );
            }
            _this.isLoader = true;

            _this.order_data.balance_after_order =
                parseFloat(_this.term_payment_info.avalaible_on_account) -
                parseFloat(_this.order_data.grand_total_price);
            _this.order_data.term_payment_info = _this.term_payment_info;
            _this.order_data.admin_user_id =
                localStorage.getItem("admin_user_id");
            new Promise(() => {
                ApiService.post("/placeordernew", _this.order_data)
                    .then(({ data }) => {
                        _this.isLoader = false;
                        _this.placingOrder = false;
                        document.getElementById("popup-close-address").click();
                        if (data.success) {
                            _this.$toast.success(data.message, {
                                position: "top-right"
                            });
                            _this.emptyCart();
                            localStorage.removeItem(
                                "billingAddressIdAfterNewAddress"
                            );
                            localStorage.removeItem(
                                "shippingAddressIdAfterNewAddress"
                            );
                            setTimeout(() => {
                                this.$router.push({
                                    name: "thankyou",
                                    params: {
                                        unique_order_id: data.unique_order_id,
                                        last_order_detail_id:
                                            data.last_order_detail_id,
                                        order_id: data.order_id
                                    }
                                });
                            }, 200);
                        } else {
                            console.log(data);
                            localStorage.removeItem(
                                "billingAddressIdAfterNewAddress"
                            );
                            localStorage.removeItem(
                                "shippingAddressIdAfterNewAddress"
                            );
                        }

                        this.$root.$emit("update-cart");
                    })
                    .catch((response) => {
                        console.log(response);
                        _this.isLoader = false;
                        _this.placingOrder = false;
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        emptyCart() {
            var _this = this;
            localStorage.removeItem("cart");
            localStorage.setItem("cartNotEmpty", false);
            _this.cart_items = [];

            if (_this.currentUserClient.id) {
                _this.isBusy = true;
                ApiService.post("/empty-cart")
                    .then(() => {
                        _this.isBusy = false;
                    })
                    .catch((response) => {
                        console.log(response);
                        _this.isBusy = false;
                    });
                return;
            }

            _this.$root.$emit("update-cart");
        },
        getUser() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/user-profile")
                    .then(({ data }) => {
                        let user = data.user;
                        console.log(
                            user,
                            user["email_activation"],
                            "checkout here aaaaaaaa"
                        );

                        if (!user["email_activation"]) {
                            _this.email_verified = true;
                            _this.getting_email = user["email"];
                        }

                        if (this.currentUserClient.netsuite_id) {
                            this.getCustomerDetailsFromNetsuite(
                                this.currentUserClient.netsuite_id
                            );
                            this.getCustomerTermDetails(
                                this.currentUserClient.netsuite_id
                            );
                        }
                    })
                    .catch(({ response }) => {
                        console.log(response);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        getCustomerDetailsFromNetsuite(external_id) {
            return new Promise((resolve, reject) => {
                let params = { external_id };
                ApiService.query("get-customer-from-netsuite", { params })
                    .then(async ({ data }) => {
                        this.netsuite_customer_data = data.customer;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        this.$toast.error(
                            "getCustomerDetailsFromNetsuite: Something went wrong",
                            { position: "top-right" }
                        );
                        reject(response);
                    });
            });
        },
        getCustomerTermDetails(external_id) {
            return new Promise((resolve, reject) => {
                ApiService.query("/get-customer-term-details", {
                    params: { external_id }
                })
                    .then(async ({ data }) => {
                        if (!data.success) {
                            this.$toast.error(
                                "Something went wrong in term payment, Please contact administrator.",
                                { position: "top-right", queue: true }
                            );
                            return;
                        }

                        let termDetails = data.termDetails;
                        if (termDetails.length > 0) {
                            await this.getUnsyncedOrdersAmount();

                            let term_payment_details = termDetails[0];

                            this.term_payment_info.creditlimit = parseFloat(
                                term_payment_details.creditlimit || 0
                            );
                            this.term_payment_info.overdue_balance = parseFloat(
                                term_payment_details.overdue_balance || 0
                            );
                            this.term_payment_info.unbilled_orders =
                                parseFloat(
                                    term_payment_details.unbilled_orders || 0
                                ) + parseFloat(this.unsynced_orders_amount);
                            this.term_payment_info.unpaid_invoices = parseFloat(
                                term_payment_details.unpaid_invoices || 0
                            );
                            this.term_payment_info.avalaible_on_account =
                                parseFloat(
                                    term_payment_details.avalaible_on_account ||
                                        0
                                ) - parseFloat(this.unsynced_orders_amount);
                            this.term_payment_info.unapplied_credits =
                                parseFloat(
                                    term_payment_details.unapplied_credits || 0
                                );
                        }

                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },
        updateCustomerInNetsuite(sameaddress, address_data) {
            return new Promise((resolve, reject) => {
                let params = {
                    id: this.currentUserClient.id,
                    first_name: this.currentUserClient.first_name,
                    last_name: this.currentUserClient.last_name,
                    email: this.currentUserClient.email,
                    alt_phone_no: address_data.phone_no,
                    mobile: this.currentUserClient.mobile,
                    external_id: this.currentUserClient.netsuite_id,
                    same_address: sameaddress,
                    address_data: address_data
                };

                if (address_data && address_data["billing_address"]) {
                    params["alt_phone_no"] =
                        address_data["billing_address"]["phone"];
                    params["email"] = address_data["billing_address"]["email"];
                } else if (address_data && address_data["shipping_address"]) {
                    params["alt_phone_no"] =
                        address_data["shipping_address"]["phone"];
                    params["email"] = address_data["shipping_address"]["email"];
                }

                ApiService.post("update-customer-in-netsuite", params)
                    .then((response) => {
                        setTimeout(() => {
                            this.getCustomerDetailsFromNetsuite(
                                response.data.external_id
                            ).then((data) => {
                                resolve(data.customer);
                            });
                        }, 1000);
                    })
                    .catch((response) => {
                        this.$toast.error(
                            "updateCustomerInNetsuite: Something went wrong",
                            { position: "top-right" }
                        );
                        reject(response);
                    });
            });
        },
        getOrdersCount() {
            return new Promise((resolve, reject) => {
                ApiService.get("/orders-count")
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.total_orders = data.total_orders;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getUnsyncedOrdersAmount() {
            return new Promise((resolve, reject) => {
                ApiService.get("/unsynced-orders-amount")
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.unsynced_orders_amount = data.total_amount;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
    }
};
</script>
